import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"
import moment from "moment"
import DateRange from "@/components/partials/DateRange"

function ClientGrowth() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [historical, setHistorical] = useState([])
  const [predicted, setPredicted] = useState([])
  const year = moment().year()

  const [filters, setFilters] = useState({
    start: year - 2,
    end: year + 4,
  })

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(
      `analytics/client-growth?date_from=01-01-${filters.start}&date_to=01-01-${filters.end}`,
    )
      .then((res) => {
        setLabels(
          res.data.chart_data.labels?.map((date) => {
            return moment(date, "YYYY").isSame(moment(), "year") ? trans("analytics.today") : date
          }) || [],
        )
        setHistorical(res.data.chart_data.historical || [])
        setPredicted(res.data.chart_data.predicted || [])

        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const historicalSeries = labels.map((_, i) =>
    i < historical.length ? (historical[i] ?? null) : null,
  )

  const boundaryIndex = historical.length - 1
  const predictedSeries = labels.map((_, i) => {
    if (i === boundaryIndex) return historical[boundaryIndex] ?? null
    if (i > boundaryIndex) return predicted[i - historical.length] ?? null
    return null
  })

  function hasAnyData() {
    return labels.length > 0
  }

  return (
    <div className="repair-requests-chart">
      <div className="head">
        <h3>{trans("analytics.clientGrowth")}</h3>
        <div className="right">
          <DateRange
            startDate={filters.start}
            endDate={filters.end}
            onStartDateChange={(date) => {
              setFilters((prev) => ({ ...prev, start: date }))
            }}
            onEndDateChange={(date) => {
              setFilters((prev) => ({ ...prev, end: date }))
            }}
            yearOnly
          />
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          series={[
            {
              id: "cg-hist",
              curve: "linear",
              label: trans("analytics.historicalData"),
              area: true,
              data: historicalSeries,
              color: "#4A3AFF",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
            {
              id: "cg-pred",
              curve: "linear",
              label: trans("analytics.forecast"),
              data: predictedSeries,
              color: "#4A3AFF",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
          ]}
          height={295}
          sx={{
            "& .MuiLineElement-series-cg-pred": { strokeDasharray: "6 3" },
            "& .MuiAreaElement-series-cg-hist": {
              fill: "url(#cg-hist-gradient)",
            },
            "& .MuiLineElement-root": { strokeWidth: 1 },
          }}
          slotProps={{
            legend: { hidden: true },
          }}
        >
          <defs>
            <linearGradient id="cg-hist-gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4A3AFF" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#4A3AFF" stopOpacity={0.02} />
            </linearGradient>
          </defs>
        </LineChart>
      )}
    </div>
  )
}

export default ClientGrowth
